<template>
  <v-card class="session__container">
    <ChooseLanguage :positionAbsolute="true" />

    <div>
      <v-img
        src="@/static/brand_logo.svg"
        class="mx-auto session__logo"
        aspect-ratio
      >
      </v-img>
    </div>
    <div class="content">
      <div class="content__image">
        <img src="@/static/session/employee.svg" />
      </div>
      <div class="content__title">
        {{ $t("message.session.employeePage.title") }}
      </div>
      <div class="content__text">
        {{ $t("message.session.employeePage.description1") }}
      </div>
      <div class="content__text">
        {{ $t("message.session.employeePage.description2") }}
      </div>
      <p class="content__secondary-text">
        {{ $t("message.session.employeePage.ifHaveAnAccount") }}
      </p>
      <div class="content__actions">
        <v-btn
          large
          outlined
          color="primary"
          :to="{ name: 'session-select-account-type' }"
        >
          {{ $t("message.common.back") }}
        </v-btn>
        <v-btn
          large
          style="width:100%; flex-shrink:1; "
          color="primary"
          :to="{ name: 'session-login' }"
        >
          {{ $t("message.common.login") }}
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import ChooseLanguage from "@/components/AppBar/ChooseLanguage.vue";

export default {
  name: "AccountTypeSelectionPage",
  components: {
    ChooseLanguage
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/accountTypeSelection.scss";

.session__container {
  @media screen and (max-height: $heightBreakpoint) {
    padding-top: $spacing * 6;
    padding-bottom: $spacing * 6;
  }
}

.content {
  padding: 0 $spacing * 12.5 $spacing * 4 $spacing * 12.5;

  @media screen and (max-height: $heightBreakpoint) {
    padding-bottom: 0;
  }

  &__actions {
    display: flex;
    gap: $spacing * 2;
    margin-top: $spacing * 4.5;

    @media screen and (max-height: $heightBreakpoint) {
      margin-top: $spacing * 3;
    }
  }

  &__image {
    height: 195px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    text-align: center;
    margin: $spacing 0;
    font-weight: 600;
    @include font-size(22px);

    &--highlighted {
      color: $primary;
    }
  }

  &__text {
    & + & {
      margin-top: $spacing * 2;
    }
  }

  &__secondary-text {
    margin-top: $spacing * 4.5;

    @media screen and (max-height: $heightBreakpoint) {
      margin-top: $spacing * 3;
    }
  }

  &__text,
  &__secondary-text {
    text-align: center;
    font-weight: 400;
    margin-bottom: 0;
  }
}
</style>
